export function getCurrentCookie(key?: string) {
  const currentCookies = document.cookie.split('; ')
  const cookie = currentCookies.reduce((pre, cur) => {
    const [key, value] = cur.split('=')
    pre[key] = value
    return pre
  }, {} as { [key: string]: string | undefined })

  return key ? cookie[key] : cookie
}
